import { render, staticRenderFns } from "./ContactsListPosts.vue?vue&type=template&id=55233569&"
import script from "./ContactsListPosts.vue?vue&type=script&lang=js&"
export * from "./ContactsListPosts.vue?vue&type=script&lang=js&"
import style0 from "./ContactsListPosts.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ContactsListPosts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports